import { PasswordField } from '@elementary/common-ui/components';
import FormControls from '@elementary/common-ui/components/FormControls';
import { AuthSectionProps } from './types';

const DefaultAuthSection = ({
  formMethods,
  requiredLabel,
}: AuthSectionProps) => {
  const {
    register,
    formState: { errors, dirtyFields },
    setValue,
  } = formMethods;
  return (
    <FormControls.InputWrapper>
      <PasswordField
        {...register('lookerGitToken', {
          required: requiredLabel,
        })}
        label="Token"
        isFormValueDirty={dirtyFields.lookerGitToken}
        clearFormValue={() => setValue('lookerGitToken', '')}
      />
      <FormControls.ErrorMessage>
        {errors.lookerGitToken?.message}
      </FormControls.ErrorMessage>
    </FormControls.InputWrapper>
  );
};

export default DefaultAuthSection;
